  <!-- 承运商核销总表 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" @moreHandle="topCommandBtns" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" @changeCallback="rowCallback">
      <template slot="time1">
        <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
      </template>
    </input-plug>
    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" :defaulthead="myTableHeard" :totals="totalArr" ref="mytable" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 整单核销 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle(1)" :isShowDialog="isShowDialog_1" @handleCloseDia="handleCloseDia(1)" @diaCancelBtn="diaCancelBtn(1)" @diaConfirmBtn="diaConfirmBtn(1)">
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules_1" :Reset="isShowDialog_1">
        <template slot="phone">
          <uploadimgs @input="changeFileList" :fileNameLists="fileNameLists" :limit="6" />
        </template>
      </dia-form>
    </my-dialog>
    <!-- 部分核销 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle(2)" :isShowDialog="isShowDialog_2" @handleCloseDia="handleCloseDia(2)" @diaCancelBtn="diaCancelBtn(2)" @diaConfirmBtn="diaConfirmBtn(2)">
      <dia-form :diaFormConfig="diaFormConfig_2" :baseModel="baseModel_2" ref="diaform_2" :rules="formRules_2" :Reset="isShowDialog_2">
        <template slot="phone">
          <uploadimgs @input="changeFileList_2" :fileNameLists="fileNameLists_2" :limit="6" />
        </template>
      </dia-form>
    </my-dialog>
    <!-- 核销记录 -->
    <my-dialog
      :diaWidth="diaWidth"
      :double="false"
      :dialogTitle="dialogTitle(3)"
      :isShowDialog="isShowDialog_3"
      @handleCloseDia="handleCloseDia(3)"
      @diaCancelBtn="diaCancelBtn(3)"
      @diaConfirmBtn="diaConfirmBtn(3)"
    >
      <record-table :tableConfig="writeoffTable" :tableHeads="W_tableHeads" @selectChange="w_selectChange" @rowCallback="w_rowMethods" />
      <el-dialog title="核销图片" append-to-body :visible.sync="dialogVisible">
        <el-image v-for="(item, index) in srcList" :key="index" style="width: 100px; height: 100px" :src="item" :preview-src-list="srcList" />
      </el-dialog>
    </my-dialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 查询列表 -->
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" @changeCallback="rowCallback">
        <template slot="time1">
          <multitime :timeType="timeType" :timeTypes="timeTypes" :startTime="startTime_a" :endTime="endTime_a" @timestatus="timestatus" @queryBtn_ok="queryBtn_time" />
        </template>
      </input-plug>
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import { FMMixinOther } from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/FMMixinOther";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import uploadimgs from "@/components/upLoadImgs.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, FMMixinOther, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    uploadimgs,
    RecordTable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "承运商核销总表", //导出时默认文件名
        apiName: "/admin/v4/finance/getCustomerFinanceList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      // BTN_CONFIG: [
      //   {
      //     name: "整单核销",
      //     method: "allWriteoff",
      //   },
      //   {
      //     name: "部分核销",
      //     method: "partWriteoff",
      //   },
      //   {
      //     name: "核销记录",
      //     method: "writeoffRecord",
      //   },
      //   {
      //     name: "生成对账单",
      //     method: "generatState",
      //   },
      //   {
      //     type: true,
      //     name: "更多操作",
      //     options: [
      //       {
      //         handleName: "dc",
      //         label: "导出",
      //       },
      //       {
      //         handleName: "bgsz",
      //         label: "表格设置",
      //       },
      //       {
      //         handleName: "dy",
      //         label: "打印",
      //       },
      //     ],
      //   },
      // ],
      // 更多搜索
      // isHaseMore: false,
      //  查询框
      // baseConfig: [
      //   {
      //     type: "timeSelect",
      //     slotName: "time1",
      //   },
      //   {
      //     type: "select",
      //     label: "结算对象",
      //     field: "objectStatusConfDictId",
      //     placeholder: "请输入",
      //     setLabel: "val",
      //     setValue: "confDictId",
      //     selectOptions: [],
      //   },
      //   {
      //     type: "select",
      //     label: "费项",
      //     field: "categoryId",
      //     placeholder: "请输入",
      //     selectOptions: [{ label: "全部", val: "1" }],
      //   },
      //   {
      //     type: "select",
      //     label: "单据类型",
      //     field: "documentStatus",
      //     placeholder: "请输入",
      //     selectOptions: [{ label: "全部", val: "1" }],
      //   },
      //   {
      //     type: "input",
      //     label: "来源单号",
      //     field: "documentNumber",
      //     placeholder: "请输入",
      //   },
      //   {
      //     type: "select",
      //     label: "核销状态",
      //     field: "writeoffStatus",
      //     placeholder: "请输入",
      //     selectOptions: [
      //       { label: "未核销", val: "wei_he_xiao:writeoff_status" },
      //       { label: "已核销", val: "yi_he_xiao:writeoff_status" },
      //     ],
      //   },
      //   {
      //     type: "select",
      //     label: "业务部门",
      //     field: "dutyDeptId",
      //     placeholder: "请输入",
      //     selectOptions: [{ label: "全部", val: "1" }],
      //   },
      // ],

      // queryData: {
      //   categoryId: null,
      //   documentNumber: null,
      //   documentStatus: null,
      //   dutyDeptId: null,
      //   endCreateTime: null,
      //   number: null,
      //   objectName: null,
      //   startCreateTime: null,
      //   writeoffStatus: null,
      // },
      //  时间类型
      // timeTypes: [
      //   {
      //     value: "0",
      //     label: "业务日期",
      //   },
      // ],
      // timeType: "0", //  时间类型
      // startTime_a: "",
      // endTime_a: "",
      // 表格配置
      // tableConfig: {
      //   tableHeigth: "75vh",
      //   tableData: [],
      // },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "关联运单号",
          field: "waybillNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "收支单据号",
          field: "number",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: false, //表格设置里面是否可以排序
        },
        {
          name: "责任部门",
          field: "dutyDeptName",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "收支类型",
          field: "financeTypeShow",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "单据类型",
          field: "documentStatusShow",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "来源单据",
          field: "documentNumber",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "费项类型",
          field: "categoryName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "费项",
          field: "serviceName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "140",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算对象",
          field: "objectName",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "结算金额",
          field: "settlementAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "已核销金额",
          field: "writeoffAmount",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "剩余核销金额",
          field: "unwriteoffAmount",
          width: "140",
          sort: 2,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "结算方式",
          field: "settlementMethod",
          width: "120",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "备注",
          field: "comment",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "对账单号",
          field: "accountStatementNumber",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "审核状态",
          field: "approveStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "审核人",
          field: "approverUserName",
          width: "120",
          sort: 180,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "核销状态",
          field: "writeoffStatusShow",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "最新核销人",
          field: "writeoffUserName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "最新核销时间",
          field: "writeoffTime",
          width: "140",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "最新资金账号",
          field: "zjAccount",
          width: "140",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "最新核销备注",
          field: "writeoffComment",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "过账时间",
          field: "createTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      // tableType: "finance_in",
      pageGroupName: "CarrierVerificationSummary",
      sortName: "承运商核销总表", //  排序名
      // 整单核销弹窗
      // diaWidth: "60%",
      // isShowDialog_1: false,
      // diaFormConfig: [
      //   {
      //     gutter: 0,
      //     formItem: [
      //       {
      //         span: 8,
      //         title: "核销金额",
      //         itemType: "input",
      //         field: "moneys",
      //         placeholder: "请输入",
      //       },
      //       {
      //         span: 8,
      //         title: "核销资金账号",
      //         itemType: "select",
      //         field: "accountId",
      //         placeholder: "请选择",
      //         labelwidth: 120,
      //         setLabel: "account",
      //         setValue: "assetaccountId",
      //         options: [],
      //       },
      //       {
      //         span: 8,
      //         title: "核销时间",
      //         field: "writeOffTime",
      //         itemType: "datetime",
      //         placeholder: "选择时间",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 0,
      //     formItem: [
      //       {
      //         span: 24,
      //         title: "备注",
      //         itemType: "textarea",
      //         field: "writeoffComment",
      //         placeholder: "请选择",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 0,
      //     formItem: [
      //       {
      //         span: 24,
      //         title: "图片",
      //         itemType: "upload",
      //         slot: "phone",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 0,
      //     formItem: [
      //       {
      //         span: 8,
      //         title: "操作时间",
      //         itemType: "input",
      //         field: "oprationTime",
      //         placeholder: "自动填写",
      //         disabled: true,
      //       },
      //       {
      //         span: 8,
      //         title: "操作人",
      //         itemType: "input",
      //         field: "oprationer",
      //         placeholder: "自动填写",
      //         disabled: true,
      //       },
      //     ],
      //   },
      // ],
      // baseModel: {
      //   moneys: 0,
      //   oprationer: "",
      //   oprationTime: "",
      // },
      // defaultBaseModel: {
      //   accountId: null,
      //   financeIds: null,
      //   writeOffPics: null,
      //   writeOffTime: null,
      //   writeoffComment: null,
      // },
      // fileNameLists: [],
      // formRules_1: {
      //   writeOffTime: [
      //     { required: true, message: "请选择时间", trigger: "change" },
      //   ],
      //   accountId: [{ required: true, message: "请选择", trigger: "change" }],
      // },
      // 部分核销
      // isShowDialog_2: false,
      // diaFormConfig_2: [
      //   {
      //     gutter: 16,
      //     formItem: [
      //       {
      //         span: 8,
      //         title: "总金额",
      //         itemType: "input",
      //         field: "allmoneys",
      //         labelwidth: 120,
      //         placeholder: "请输入",
      //       },
      //       {
      //         span: 8,
      //         title: "本次核销金额",
      //         itemType: "input",
      //         labelwidth: 120,
      //         field: "writeoffAmount",
      //         placeholder: "请输入",
      //       },
      //       {
      //         span: 8,
      //         title: "剩余核销金额",
      //         itemType: "input",
      //         field: "surplusmoney",
      //         placeholder: "请输入",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 16,
      //     formItem: [
      //       {
      //         span: 8,
      //         title: "核销资金账号",
      //         itemType: "select",
      //         field: "accountId",
      //         placeholder: "请选择",
      //         labelwidth: 120,
      //         setLabel: "account",
      //         setValue: "assetaccountId",
      //         options: [],
      //       },
      //       {
      //         span: 8,
      //         title: "核销时间",
      //         itemType: "datetime",
      //         field: "writeOffTime",
      //         placeholder: "选择时间",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 16,
      //     formItem: [
      //       {
      //         span: 24,
      //         title: "备注",
      //         itemType: "textarea",
      //         field: "writeoffComment",
      //         placeholder: "请选择",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 0,
      //     formItem: [
      //       {
      //         span: 24,
      //         title: "图片",
      //         itemType: "upload",
      //         slot: "phone",
      //       },
      //     ],
      //   },
      //   {
      //     gutter: 16,
      //     formItem: [
      //       {
      //         span: 8,
      //         title: "操作时间",
      //         itemType: "input",
      //         field: "oprationTime",
      //         placeholder: "自动输入",
      //         disabled: true,
      //       },
      //       {
      //         span: 8,
      //         title: "操作人",
      //         itemType: "input",
      //         field: "oprationer",
      //         placeholder: "自动输入",
      //         disabled: true,
      //       },
      //     ],
      //   },
      // ],
      // baseModel_2: {
      //   allmoneys: 0,
      //   surplusmoney: 0,
      //   oprationTime: "",
      //   oprationer: "",
      // },
      // fileNameLists_2: [],
      // defaultBaseModel_2: {
      //   accountId: null,
      //   financeId: null,
      //   writeOffPics: null,
      //   writeOffTime: null,
      //   writeoffAmount: null,
      //   writeoffComment: null,
      // },
      // formRules_2: {
      //   writeOffTime: [
      //     { required: true, message: "请选择时间", trigger: "change" },
      //   ],
      //   writeoffAmount: [
      //     { required: true, message: "请输入", trigger: "blur" },
      //   ],
      //   accountId: [{ required: true, message: "请选择", trigger: "change" }],
      // },
      // // 核销记录
      // isShowDialog_3: false,
      // // 表格配置
      // writeoffTable: {
      //   maxHeight: "75vh",
      //   tableData: [],
      // },
      // W_tableHeads: [
      //   {
      //     name: "操作",
      //     field: "edit",
      //     method: "ReWriteoff",
      //     methodName: "反核销",
      //   },
      //   {
      //     name: "操作类型",
      //     field: "operationTypeShow",
      //     width: "120",
      //   },
      //   {
      //     name: "总金额",
      //     field: "settlementAmount",
      //     width: "120",
      //   },
      //   {
      //     name: "已核销金额",
      //     field: "writeoffedAmount",
      //     width: "120",
      //   },
      //   {
      //     name: "本次核销金额",
      //     field: "writeoffAmount",
      //     width: "160",
      //   },
      //   {
      //     name: "剩余待核销金额",
      //     field: "unwriteoffAmount",
      //     width: "160",
      //   },
      //   {
      //     name: "核销资金账号",
      //     field: "zjAccount",
      //     width: "120",
      //   },
      //   {
      //     name: "核销人",
      //     field: "writeoffUserName",
      //     width: "120",
      //   },
      //   {
      //     name: "核销时间",
      //     field: "writeoffTime",
      //     width: "120",
      //   },
      //   {
      //     name: "核销备注",
      //     field: "writeoffComment",
      //     width: "120",
      //   },
      //   {
      //     name: "操作时间",
      //     field: "operationTime",
      //     width: "120",
      //   },
      //   {
      //     name: "图片",
      //     width: "120",
      //     hasButton: true,
      //     disabled: false,
      //     method: "viewImages",
      //     methodName: "点击查看",
      //   },
      // ],
      // srcList: [],
      // dialogVisible: false,
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    // this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    // this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;
    this.GetData();
    // this.getConfDictValDownList("object_status");
    // this.getAssetaccountList();
  },
  methods: {
    // 获取应收总表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.queryData.startCreateTime = this.startTime_a
        ? this.startTime_a + " 00:00:00"
        : "";
      this.queryData.endCreateTime = this.endTime_a
        ? this.endTime_a + " 23:59:59"
        : "";
      this.queryData.objectStatusConfDictKey = "carrier";
      this.$API.getCustomerFinanceList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---应收总表`);
        }
      });
    },

    // 获取结算对象类型
    // getConfDictValDownList(PARAM) {
    //   this.$API.wtl_getConfDictValDownList({ dictType: PARAM }).then((res) => {
    //     if (res.data.status === "success") {
    //       this.baseConfig[1].selectOptions = res.data.result || [];
    //     } else {
    //       console.log(res.data.message);
    //     }
    //   });
    // },

    // 获取已启用的资金账号列表
    getAssetaccountList() {
      this.$API.assetaccountList({ isShow: "1" }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.diaFormConfig[0].formItem[1].options = result;
          this.diaFormConfig_2[1].formItem[0].options = result;
        } else {
          console.log(res.data.message);
        }
      });
    },

    // // 获取核销记录
    // getRecord(id) {
    //   this.$API.FinanceInWriteoffRecorList({ financeId: id }).then((res) => {
    //     if (res.data.status === "success") {
    //       this.writeoffTable.tableData = res.data.result || [];
    //     } else {
    //       console.log(res.data.message);
    //     }
    //   });
    // },
    // 财务返核销
    // FinanceInUnWriteOff(id) {
    //   this.$API.financeInUnWriteOff({ recordId: id }).then((res) => {
    //     if (res.data.status === "success") {
    //       this.getRecord(this.selectTableData[0].financeId);
    //       this.$message.success(res.data.message);
    //     } else {
    //       console.log(res.data.message);
    //     }
    //   });
    // },
    // 整单核销
    // allWriteoff(data) {
    //   if (data) this.selectTableData = [data];
    //   if (this.selectTableData.length > 0) {
    //     let moneyNum = 0;
    //     this.baseModel.financeIds = [];
    //     this.baseModel.oprationer = this.selectTableData[0].writeoffUserName;
    //     this.baseModel.oprationTime = this.selectTableData[0].createTime;
    //     for (let i in this.selectTableData) {
    //       moneyNum += Number(this.selectTableData[i].settlementAmount);
    //       this.baseModel.financeIds.push(this.selectTableData[i].financeId);
    //     }

    //     this.baseModel.moneys = moneyNum.toFixed(2);
    //     this.isShowDialog_1 = true;
    //   } else {
    //     this.$message.error("请选择至少一条数据进行操作");
    //     return false;
    //   }
    // },

    // 部分核销
    // partWriteoff(data) {
    //   if (data) this.selectTableData = [data];
    //   if (this.selectTableData.length !== 1) {
    //     this.$message.error("请选择一条数据进行操作");
    //     return false;
    //   } else {
    //     this.baseModel_2.financeIds = [];
    //     this.baseModel_2.allmoneys = this.selectTableData[0].settlementAmount;
    //     this.baseModel_2.surplusmoney =
    //       this.selectTableData[0].unwriteoffAmount;
    //     this.baseModel_2.financeId = this.selectTableData[0].financeId;
    //     this.baseModel_2.oprationTime = this.selectTableData[0].createTime;
    //     this.baseModel_2.oprationer = this.selectTableData[0].writeoffUserName;
    //     this.isShowDialog_2 = true;
    //   }
    // },

    // 核销记录
    // writeoffRecord(data) {
    //   if (data) this.selectTableData = [data];
    //   if (this.selectTableData.length !== 1) {
    //     this.$message.error("请选择一条数据进行操作");
    //     return false;
    //   } else {
    //     this.getRecord(this.selectTableData[0].financeId);
    //     this.isShowDialog_3 = true;
    //   }
    // },

    // 更多搜索
    // moreParam(e) {
    //   this.isHaseMore = e;
    //   this.$nextTick(() => {
    //     this.fetTableHeight();
    //   });
    // },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        // this.exportBtn();
        this.isShowDialog_dc = true;
      }
    },
    // 当前弹窗的标题赋值
    // dialogTitle(e) {
    //   return e === 1
    //     ? "整单核销"
    //     : e === 2
    //     ? "部分核销"
    //     : e === 3
    //     ? "核销记录"
    //     : "编辑";
    // },
    // 清空查询
    // clearBtns() {
    //   this.$refs["queryForm"].$refs.forms.resetFields();
    //   this.startTime_a = "";
    //   this.endTime_a = "";
    //   this.GetData();
    // },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    viewImages(val) {
      let imgs = val?.fileIds || [];
      this.$API.getFileUrlMore({ fileNames: imgs }).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result;
          this.srcList = [];
          for (let i in result) {
            this.srcList.push(result[i].url);
          }
          this.dialogVisible = true;
        } else {
          console.log(res.data.message);
        }
      });
    },
    // 时间查询框选择时间时的事件
    // queryBtn_time(t1, t2) {
    //   this.startTime_a = t1;
    //   this.endTime_a = t2;
    //   if (t1 && t2) {
    //     this.GetData();
    //   }
    // },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    // 整单核销
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    // handleCloseDia(e) {
    //   this.diaCancelBtn(e);
    // },
    //  弹窗确认保存事件
    // diaConfirmBtn(e) {
    //   if (e == 1) this.ZDcomfirm();
    //   if (e === 2) this.BFcomfirm();
    //   if (e === 3) this.recordComfirm();
    // },
    //  关闭弹窗按钮事件(关闭按钮)
    // diaCancelBtn(e) {
    //   this.selectTableData.length = 0;
    //   this.$refs.mytable.$refs.tables.clearSelection();
    //   if (e == 1) {
    //     this.baseModel = {
    //       moneys: 0,
    //       oprationer: "",
    //       oprationTime: "",
    //     };
    //     this.isShowDialog_1 = false;
    //   } else if (e === 2) {
    //     this.baseModel_2 = {
    //       allmoneys: 0,
    //       surplusmoney: 0,
    //       oprationTime: "",
    //       oprationer: "",
    //     };
    //     this.isShowDialog_2 = false;
    //   } else if (e === 3) this.isShowDialog_3 = false;
    // },

    // 整单核销确认按钮
    // ZDcomfirm() {
    //   this.$refs["diaform"].$refs.addForm.validate((valid) => {
    //     if (valid) {
    //       // 正常提交
    //       let param = {};
    //       for (let key in this.defaultBaseModel) {
    //         if (this.baseModel[key]) {
    //           eval("param." + key + "='" + this.baseModel[key] + "'");
    //         } else {
    //           eval("param." + key + "=''");
    //         }
    //       }
    //       param.writeOffPics = [];
    //       for (let i in this.fileNameLists) {
    //         param.writeOffPics.push(this.fileNameLists[i].name);
    //       }
    //       param.financeIds = this.baseModel.financeIds;
    //       // 修改接口
    //       this.$API.financeInWriteOff(param).then((res) => {
    //         if (res.data.status === "success") {
    //           this.$message.success(res.data.message);
    //           this.isShowDialog_1 = false;
    //           this.GetData();
    //         }
    //       });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // 部分核销确认按钮
    // BFcomfirm() {
    //   this.$refs["diaform_2"].$refs.addForm.validate((valid) => {
    //     if (valid) {
    //       // 正常提交
    //       let param = {};
    //       for (let key in this.defaultBaseModel_2) {
    //         if (this.baseModel_2[key]) {
    //           eval("param." + key + "='" + this.baseModel_2[key] + "'");
    //         } else {
    //           eval("param." + key + "=''");
    //         }
    //       }
    //       param.writeOffPics = [];
    //       for (let i in this.fileNameLists_2) {
    //         param.writeOffPics.push(this.fileNameLists_2[i].name);
    //       }
    //       this.$API.financeInPartWriteOff(param).then((res) => {
    //         if (res.data.status === "success") {
    //           this.$message.success(res.data.message);
    //           this.isShowDialog_2 = false;
    //           this.GetData();
    //         }
    //       });
    //     } else {
    //       console.log("error submit!!");
    //       return false;
    //     }
    //   });
    // },
    // 核销记录确认按钮
    // recordComfirm() {
    //   this.isShowDialog_3 = false;
    // },
    // // 整单核销选择图片
    // changeFileList(array) {
    //   this.fileNameLists = array;
    // },
    // // 部分核销选择图片
    // changeFileList_2(array) {
    //   this.fileNameLists_2 = array;
    // },
    // 核销记录
    w_selectChange(e) {
      console.log(e);
    },
    w_rowMethods(e, t) {
      this[t](e);
    },
    // 财务反核销
    // ReWriteoff(e) {
    //   this.$API.financeInUnWriteOff({ recordId: e.recordId }).then((res) => {
    //     if (res.data.status === "success") {
    //       this.$message.success(res.data.message);
    //       this.getRecord(this.selectTableData[0].financeId);
    //     } else {
    //       this.$message.warning(res.data.message);
    //     }
    //   });
    // },
  },
};
</script>
  <style scoped lang="less">
</style>
  